import React, { useContext } from "react";
import { SimpleContext } from "../../../../store/context/simple-context";
import { getTrueClasses } from "../../../../helpers";
import "./index.scss";

const MainTitle = () => {
  const {
    translate: { countryCode, t },
  } = useContext(SimpleContext);
  return (
    <div
      className={getTrueClasses(
        "GP-C-MB",
        countryCode === "US" && "GP-C-MB_addText"
      )}
    >
      <p className="GP-C-MB__title">{t("Simple and Transparent Pricing")}</p>
      <p className="GP-C-MB__subTitle">
        {t(
          "Ideal for Amazon Sellers of All Levels and Various Business Models"
        )}
      </p>
      {countryCode === "US" && (
        <p className="GP-C-MB__text">
          {t(
            "Buy now, pay later through 4 interest-free installments, available for annual and lifetime plans"
          )}
        </p>
      )}
    </div>
  );
};

export default MainTitle;
